<script lang="ts" setup>
import { useI18n } from 'vue-i18n'
import { RouterLinkProps } from 'vue-router'

export interface Props extends RouterLinkProps {
    translation: string
    activated?: boolean
    requiresModuleLicense?: boolean
}

const props = withDefaults(defineProps<Props>(), { activated: true })
const { t } = useI18n()
</script>

<template>
    <RouterLink
        v-tooltip="{
            content: t('noAccessForReadonly'),
            disabled: props.activated || (!props.activated && !props.requiresModuleLicense),
            placement: 'right',
        }"
        :to="props.to"
        :active-class="props.activated ? 'bg-yellow-500 !text-dark-500' : ''"
        class="group flex items-center rounded-lg px-3 py-2 text-sm text-primary-200 transition-colors hover:bg-dark-800 hover:text-dark-700 dark:hover:text-dark-700"
        :class="{
            'opacity-50 cursor-not-allowed': !props.activated,
            'hover:bg-yellow-600 hover:text-dark-700': props.activated,
        }"
    >
        <span class="mr-3 flex-shrink-0">
            <slot />
        </span>
        <span class="truncate">
            {{ t(props.translation) }}
        </span>
    </RouterLink>
</template>
